import { Stack, Typography } from '@mui/material';
import { CraneIcon } from 'app/icons';
import React from 'react';
export const CraneAngleSection = ({ angle }) => {
    return (React.createElement(Stack, { direction: 'row', alignItems: 'center' },
        React.createElement(CraneIcon, { degris: angle }),
        React.createElement(Typography, { marginLeft: '10px' },
            angle,
            "\u00B0")));
};
